/**
 * API Configuration
 * Centralized API URL configuration for the entire application
 */

// API Configuration Function
export const getApiUrl = () => {
    let hostname = window.location.host;
    
    // Development environment detection - use proxy to avoid CORS
    if (hostname.includes("localhost") || hostname.includes("127.0.0.1")) {
        // Use Create React App proxy during development (no CORS preflight!)
        return "/index.php/api/";
    } else {
        // Production environment - direct API call
        return "https://api.wiziai.com/index.php/api/";
    }
};

// Google OAuth Configuration
export const getGoogleOAuthConfig = () => {
    // Use environment variable for Google Client ID
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    
    if (!clientId) {
        console.warn('Google Client ID not configured. Please set REACT_APP_GOOGLE_CLIENT_ID in your environment variables.');
        return {
            clientId: "your-google-client-id.apps.googleusercontent.com",
            redirectUri: window.location.origin + "/auth/google/callback",
            scope: "openid profile email"
        };
    }

    return {
        clientId: clientId,
        redirectUri: window.location.origin + "/auth/google/callback",
        scope: "openid profile email"
    };
};

// Export the API URLs
export const API_BASE_URL = getApiUrl();
export const AI_API_URL = "https://rhythm-api-h4b2cheheaf5ftgr.centralindia-01.azurewebsites.net/";
export const GOOGLE_OAUTH_CONFIG = getGoogleOAuthConfig();

// Export default configuration object
const apiConfig = {
    API_BASE_URL,
    AI_API_URL,
    GOOGLE_OAUTH_CONFIG,
    getApiUrl,
    getGoogleOAuthConfig
};

export default apiConfig;
